<div class="year-planning-container">
    <div class="controls">
        <div class="header">
            <app-header subTitle="Jaarplanning"></app-header>
        </div>

        <div class="entity-type-selector">
            <ng-select
                class="ng-select-fill"
                [formControl]="fcEntityType"
                [clearable]="false"
                placeholder="Selecteer materieelsoort">
                @for (entityType of yearPlanningEntityTypes; track entityType.key) {
                    <ng-option [value]="entityType.key">
                        <i class="fa-regular {{ entityType.icon }}"></i>
                        {{ entityType.plural_name }}
                    </ng-option>
                }
            </ng-select>
        </div>
        <div class="actions">
            <app-settings-menu />
        </div>
    </div>

    @if (loading) {
        <div class="loading">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
    } @else if (!weeks?.length) {
        <div class="empty-state">Geen geplande werkzaamheden gevonden voor het komende jaar.</div>
    } @else {
        <div class="grid-wrapper">
            <div class="grid-scroll">
                <table class="year-grid">
                    <thead>
                        <tr class="entity-header">
                            <th class="sticky-col week-header-cell">Week</th>
                            <th class="sticky-col day-header-cell">Datum</th>
                            @for (entity of entities; track entity.id) {
                                <th class="entity-col">{{ entity.name }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (week of weeks; track week.weekNumber + '-' + week.year; let weekIndex = $index) {
                            @for (day of week.days; track day.date.getTime(); let dayIndex = $index) {
                                <tr class="day-row" [class.week-alt]="weekIndex % 2 !== 0">
                                    @if (dayIndex === 0) {
                                        <td
                                            class="sticky-col week-label"
                                            [class.week-alt]="weekIndex % 2 !== 0"
                                            [attr.rowspan]="week.days.length">
                                            <span class="week-number">{{ week.weekNumber }}</span>
                                            <span class="week-year">{{ week.year }}</span>
                                        </td>
                                    }
                                    <td class="sticky-col day-label">
                                        {{ day.date | date: 'EEE d MMM' }}
                                    </td>
                                    @for (entity of entities; track entity.id) {
                                        <td class="entity-cell" (click)="newPlanning(day, entity)">
                                            @for (
                                                item of getItemsForEntity(day, entity.id);
                                                track item.planningHas.id
                                            ) {
                                                <div
                                                    class="planning-card"
                                                    [style.border-left-color]="'#' + item.planning.status?.color"
                                                    (click)="openPlanning(item.planning); $event.stopPropagation()">
                                                    <div class="card-summary">
                                                        <span class="summary-project">{{
                                                            item.planning.afas_project_id
                                                        }}</span>
                                                        <span class="summary-location">
                                                            @if (item.planning.location_data?.country) {
                                                                <div class="town">
                                                                    {{ item.planning.location_data?.town }},
                                                                </div>
                                                                <div class="country">
                                                                    {{ item.planning.location_data?.country }}
                                                                </div>
                                                            } @else {
                                                                {{ item.planning.location }}
                                                            }
                                                        </span>

                                                        <span class="summary-contractor">{{
                                                            item.planning?.contractor
                                                        }}</span>

                                                        <span class="summary-performer">{{
                                                            item | personnelNames
                                                        }}</span>
                                                        <span class="summary-time">
                                                            @if (item.planning.planning_repetition_id) {
                                                                &nbsp;<i
                                                                    class="fa-regular fa-arrows-repeat"
                                                                    title="Herhaling"></i>
                                                            }
                                                            @if (day.items?.size > 1) {
                                                                {{ item.planningHas.begindate | date: 'H:mm' }}-{{
                                                                    item.planningHas.enddate | date: 'H:mm'
                                                                }}
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
</div>
